import { SentEmailsCounter } from '../SentEmailsCounter'

import { CurrentPlan } from './components/CurrentPlan'

interface Props {
  counters: uui.domain.server.CountryNotificationCounters
}

export function EmailPlan(props: Props) {
  const { counters } = props

  const startDate = new Date(counters.emailCountStartTs)

  return (
    <>
      <CurrentPlan />

      <SentEmailsCounter startDate={startDate} emailCount={counters.emailCount} />
    </>
  )
}
